/**
 * Diseases Component
 *
 * Description: Displays a list of diseases the doctor has experience with. If `isMyProfile` is true,
 * an edit icon is shown for modifying the diseases list.
 *
 * Props:
 * - isMyProfile (boolean): If true, displays an edit icon.
 * - diseasesDetails ({ _id: string; name: string }[]): List of diseases to display.
 *
 * File Name: Diseases.tsx
 * Date: 02-09-2024
 */

import React from "react";
import { Link } from "react-router-dom";
import edit from "../../../assets/images/awesome-edit.svg";

const Diseases: React.FC<{
  isMyProfile: boolean;
  diseasesDetails: { _id: string; name: string }[];
}> = ({ isMyProfile = false, diseasesDetails = [] }) => {
  return (
    <div className="parent-box parent-box-margin-issue relative">
      <h2 className="font-size-20px font-Poppins-SemiBold theme-color-green">
        Diseases
      </h2>
      {/* <div className="services flex items-center gap-4 flex-wrap"> */}
      <div
        className={`${
          diseasesDetails.length > 0 ? "mt-4" : ""
        } services flex items-center gap-4 flex-wrap`}
      >
        {diseasesDetails?.map((item) => (
          <div
            key={item._id}
            className="py-2 px-6 rounded-md border border-solid border-[#707070] bg-[#F3F3F3]"
          >
            <p className="font-Poppins-Light text-[#000000] font-size-19px">
              {item.name}
            </p>
          </div>
        ))}
      </div>
      {isMyProfile && (
        <Link
          id="edit-diseases-btn"
          to="/my-diseases"
          className="edit-pro-icon absolute top-2 right-4"
        >
          <img src={edit} alt="edit-icon" />
        </Link>
      )}
    </div>
  );
};

export default Diseases;
